import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

import { getMarketStore } from '@/store/use-markets-store';
import { cn } from '@/utils/cn';
import { bigIntToNum, formatBigInt } from '@/utils/value-format';

type Props = {
  symbol: string;
  className?: string;
  vertical?: boolean;
};

export default function PriceChange({ symbol, className, vertical }: Props) {
  const { priceChange, priceChangePct, priceDecimals } = useStore(
    getMarketStore(symbol),
    useShallow((state) => ({
      priceChange: state.marketData.priceChange,
      priceChangePct: state.marketData.priceChangePct,
      priceDecimals: state.marketSpec.priceDecimals,
    })),
  );
  return (
    <div
      className={cn(
        vertical && 'flex flex-col',
        {
          'text-green': priceChange > 0n,
          'text-red': priceChange < 0n,
          'text-vestgrey-100': priceChange === 0n,
        },
        className,
      )}
    >
      <span>
        {formatBigInt(priceChangePct, 4n, {
          showChange: true,
          style: 'percent',
          maxDigits: 2,
        })}
      </span>
      {!vertical && ' / '}
      <span>
        {formatBigInt(priceChange, priceDecimals, {
          abs: true,
          style: 'currency',
          digits: 2,
        })}
      </span>
    </div>
  );
}

export const priceChangeAccessorFn = (symbol: string) => {
  const { priceChangePct } = getMarketStore(symbol).getState().marketData;
  return bigIntToNum(priceChangePct, 4);
};
